import { css, styled, typographyClasses } from '@mui/material';

export const StyledClaimStatusLabel = styled('div')(
  ({ theme }) => css`
    .${typographyClasses.root} {
      align-items: center;
      column-gap: ${theme.spacing('SMALL')};
      display: flex;

      &::before {
        width: ${theme.spacing('1XL')};
        height: ${theme.spacing('1XL')};
      }
    }
  `
);

export const StyledClaimStatusSuccessLabel = styled(StyledClaimStatusLabel)`
  .${typographyClasses.root}::before {
    content: url(/images/design-assets/status_success.svg);
  }
`;

export const StyledClaimStatusInfoLabel = styled(StyledClaimStatusLabel)`
  .${typographyClasses.root}::before {
    content: url(/images/design-assets/status_info.svg);
  }
`;

export const StyledClaimStatusBlockedLabel = styled(StyledClaimStatusLabel)`
  .${typographyClasses.root}::before {
    content: url(/images/design-assets/status_blocked.svg);
  }
`;

export const StyledClaimStatusCancelledLabel = styled(StyledClaimStatusLabel)`
  .${typographyClasses.root}::before {
    content: url(/images/design-assets/status_cancelled.svg);
  }
`;
